import { METRICS, SEND_METRICS} from "../actions/metrics";
import * as AnalyticsRESTClient from "../utils/trackers/AnalyticsRESTClient";

const initialState = {
  payload:             {},
  analyticsClientType: null,
  restClientStatus:    'inactivo',
  eventCount:          0,
  lastFlushTimestamp:  null,
};

const setSendMethod = (dataLayer) => {
  // Delegar al facade cuando REST está activo; solo GA4 recibe el evento
  if (AnalyticsRESTClient.isEnabled()) {
    AnalyticsRESTClient.trackEventGA(dataLayer.hitType || 'event', dataLayer);
  } else {
    if (typeof window.ga === 'function' && dataLayer && dataLayer.hitType) window.ga('send', dataLayer.hitType, dataLayer);
  }
};

const createMetrics = (executor, payload) => {
	const isEmpty = (obj) => {
		return Object.keys(obj).length === 0 && obj.constructor === Object;
	}
  if(!isEmpty(payload)) return setSendMethod(payload);
};


const setMetrics = (state = initialState, action = {}) => {
	switch (action.type) {
        case 'METRICS':
          // Solo almacena en estado; el envío ocurre en SEND_METRICS para evitar duplicados.
          return { ...state, payload: action.payload };
        case 'SEND_METRICS':
        	const result = action.result;
        	createMetrics(result.executor, result.payload);
        	return { ...state, payload: {} };
        case 'SET_ANALYTICS_CLIENT_TYPE':
          return { ...state, analyticsClientType: action.payload };
        case 'SET_REST_STATUS':
          return { ...state, restClientStatus: action.payload };
        case 'INCREMENT_EVENT_COUNT':
          return { ...state, eventCount: state.eventCount + 1 };
        case 'SET_LAST_FLUSH':
          return { ...state, lastFlushTimestamp: action.payload };
    }
    return state;
}

export default setMetrics;



// WEBPACK FOOTER //
// ./src/reducers/metrics.js